import React from 'react';
import './Style/WeightageBiology2026.css';
import TopNavbar from '../../../home/TopNavbar';
import TopHeader from '../../../home/TopHeader';

const WeightageBiology2026 = () => {
  // Botany Table Data
  const botanyData = [
    { chapter: 'Genetics and Evolution', questions: 15, weightage: '25%' },
    { chapter: 'Ecology and Environment', questions: 10, weightage: '16%' },
    { chapter: 'Plant Physiology', questions: 8, weightage: '14%' },
    { chapter: 'Plant Diversity', questions: 7, weightage: '12%' },
    { chapter: 'Cell Structure & Function', questions: 6, weightage: '10%' },
    { chapter: 'Plant Reproduction', questions: 5, weightage: '9%' },
    { chapter: 'Morphology of Flowering Plants', questions: 4, weightage: '7%' },
    { chapter: 'Plant Anatomy', questions: 2, weightage: '4%' },
    { chapter: 'Bio-molecule', questions: 2, weightage: '3%' },
  ];

  // Zoology Table Data
  const zoologyData = [
    { chapter: 'Human Physiology', questions: 13, weightage: '45%' },
    { chapter: 'Human Reproduction & Reproductive Health', questions: 5, weightage: '16%' },
    { chapter: 'Animal Kingdom', questions: 3, weightage: '10%' },
    { chapter: 'Origin & Evolution', questions: 3, weightage: '10%' },
    { chapter: 'Human Health & Diseases', questions: 3, weightage: '9%' },
    { chapter: 'Structural Organisation in Animals', questions: 2, weightage: '5%' },
    { chapter: 'Animal husbandry', questions: 1, weightage: '3%' },
    { chapter: 'Biology and Human Welfare', questions: 1, weightage: '2%' },
  ];

  return (
    <div className="neetbio-container">
    
      <TopNavbar name="Biology Weightage 2026" ></TopNavbar>
       <TopHeader name="Biology Weightage 2026" ></TopHeader>


      {/* Main Content Body */}
      <main className="neetbio-content">
        <h2 className="neetbio-main-title">BIOLOGY Chapter-Wise Weightage</h2>

        <p className="neetbio-paragraph">
          The table below illustrates the distribution of weightage for different chapters within the Biology section of the NEET exam. Biology contributes significantly to the overall NEET score, making it essential to master these most important chapters for NEET 2026.
        </p>

        {/* Botany Section */}
        <section className="neetbio-section">
          <h3 className="neetbio-subheading">Botany</h3>
          <div className="neetbio-table-wrapper">
            <table className="neetbio-table">
              <thead>
                <tr>
                  <th>Biology Chapters and Topics</th>
                  <th className="neetbio-th-center">Average Number of Questions</th>
                  <th className="neetbio-th-center">Weightage (%)</th>
                </tr>
              </thead>
              <tbody>
                {botanyData.map((row, index) => (
                  <tr key={index}>
                    <td className="neetbio-td-chapter">{row.chapter}</td>
                    <td className="neetbio-td-center">{row.questions}</td>
                    <td className="neetbio-td-center neetbio-td-badge">
                      <span>{row.weightage}</span>
                    </td>
                  </tr>
                ))}
                {/* Total Row */}
                <tr className="neetbio-total-row">
                  <td className="neetbio-total-label">Total</td>
                  <td className="neetbio-td-center neetbio-empty-cell">&mdash;</td>
                  <td className="neetbio-td-center neetbio-total-badge">
                    <span>100%</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Zoology Section */}
        <section className="neetbio-section">
          <h3 className="neetbio-subheading">Zoology</h3>
          <div className="neetbio-table-wrapper">
            <table className="neetbio-table">
              <thead>
                <tr>
                  <th>Biology Chapters and Topics</th>
                  <th className="neetbio-th-center">Average Number of Questions</th>
                  <th className="neetbio-th-center">Weightage (%)</th>
                </tr>
              </thead>
              <tbody>
                {zoologyData.map((row, index) => (
                  <tr key={index}>
                    <td className="neetbio-td-chapter">{row.chapter}</td>
                    <td className="neetbio-td-center">{row.questions}</td>
                    <td className="neetbio-td-center neetbio-td-badge">
                      <span>{row.weightage}</span>
                    </td>
                  </tr>
                ))}
                {/* Total Row */}
                <tr className="neetbio-total-row">
                  <td className="neetbio-total-label">Total</td>
                  <td className="neetbio-td-center neetbio-empty-cell">&mdash;</td>
                  <td className="neetbio-td-center neetbio-total-badge">
                    <span>100%</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </main>

     
    </div>
  );
};

export default WeightageBiology2026;